"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledImage = exports.ImageWrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var ImageWrapper = exports.ImageWrapper = _styledComponents["default"].figure(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0 !important;\n  z-index: auto;\n  display: block;\n"])));
var StyledImage = exports.StyledImage = _styledComponents["default"].img(function (_ref) {
  var display = _ref.display;
  return "\n  width: 20px;\n  height: 15px;\n  object-fit: contain;\n  z-index: auto;\n  display: ".concat(display ? 'block' : 'none', ";\n");
});